import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, TextField, CircularProgress } from '@material-ui/core';

import ActionsComments from '../../../../../store/ducks/comments';

import useStyles from './styles';

const InputComment = props => {
  const { editComment, replyComment, onCancel, onStore, comments } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { course: courseId, lesson: lessonId } = useSelector(
    state => state.course.current,
  );
  const [loadingSend, setLoadingSend] = useState(false);
  const [value, setValue] = useState({
    text: '',
    error: false,
    editing: false,
  });

  const handleValidation = useCallback(() => {
    const isValid = !!value.text;
    setValue(oldValue => ({
      ...oldValue,
      error: !isValid,
    }));
    return isValid;
  }, [value]);

  const handleChange = useCallback(
    () => event => {
      setValue({
        text: event.target.value,
      });
    },
    [],
  );

  const handleCancelEdit = useCallback(() => onCancel(), [onCancel]);

  const handleClearComment = useCallback(() => {
    setValue({ text: '', error: false });
  }, []);

  const handleStoreComment = useCallback(() => {
    if (handleValidation()) {
      if (editComment) {
        dispatch(
          ActionsComments.requestUpdateComment(
            courseId,
            lessonId,
            editComment.id,
            value.text,
          ),
        );
      } else {
        dispatch(
          ActionsComments.requestStoreComment(
            courseId,
            lessonId,
            replyComment ? replyComment.parentId : 0,
            value.text,
          ),
        );
        onStore();
      }
      setLoadingSend(true);
    }
  }, [
    courseId,
    dispatch,
    editComment,
    handleValidation,
    lessonId,
    onStore,
    replyComment,
    value.text,
  ]);

  useEffect(() => {
    if (editComment) {
      setValue(oldValue => {
        const { editing, text: oldText } = oldValue;
        return {
          text: editing || editing === undefined ? oldText : editComment.text,
          error: false,
          editing: true,
        };
      });
    }
  }, [editComment]);

  useEffect(() => {
    setLoadingSend(oldLoadingSend => {
      if (oldLoadingSend) {
        handleClearComment();
        return false;
      }
      return oldLoadingSend;
    });
  }, [comments, handleClearComment]);

  return (
    <Box className={`${classes.container} ${replyComment ? 'reply' : ''}`}>
      <TextField
        className="comment-input"
        id="comments-new-input"
        placeholder={`Escreva ${
          replyComment ? 'sua resposta' : 'seu comentário'
        }...`}
        helperText={
          value.error
            ? 'Escreva o texto do seu comentário antes de salvar.'
            : ''
        }
        rows={4}
        rowsMax={8}
        multiline
        variant="outlined"
        InputProps={{ classes: { root: classes.input } }}
        name="comment"
        error={value.error}
        value={value.text}
        disabled={loadingSend}
        onChange={handleChange()}
      />
      <Box className="comment-actions">
        {(replyComment || editComment) && (
          <Button classes={{ root: classes.btn }} onClick={handleCancelEdit}>
            Cancelar
          </Button>
        )}
        <Button
          classes={{ root: classes.btn }}
          onClick={handleStoreComment}
          color="primary"
        >
          {loadingSend ? (
            <CircularProgress color="inherit" size={24} />
          ) : (
            <>{editComment ? 'Salvar' : 'Enviar'}</>
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default InputComment;
